import { doGoogleOauth, doOfficeOauth } from 'actions/auth'
import { doBootstrapOnboarding } from 'subapps/onboarding/actions'
import { ACTIVE_SIGNUP_VARIATION } from 'subapps/onboarding/constants'
import { capture } from 'ducks/tracking/actions'
import { V6_EMAIL_PAGE, V6_COMPANY_PAGE } from '../pages'
import { doFinishOnboarding } from '../actions'

export function doEmailSignup() {
  return dispatch => {
    capture('user signup email')
    dispatch({ type: V6_EMAIL_PAGE })
    return Promise.resolve()
  }
}

export function doGoogleSignup(options = {}) {
  return async dispatch => {
    const isShortSignup = ACTIVE_SIGNUP_VARIATION === 'short'
    capture('user signup google')
    const success = await dispatch(
      doGoogleOauth(
        V6_COMPANY_PAGE,
        {
          signup: true,
          ignore_existing: !!options.ignore_existing,
        },
        { rethrowErrorOnClosedPopup: true, disableRedirect: isShortSignup }
      )
    )
    if (success && isShortSignup) {
      await dispatch(doBootstrapOnboarding())
      dispatch(doFinishOnboarding())
    }
    return success
  }
}

export function doOfficeSignup(options = {}) {
  return async dispatch => {
    const isShortSignup = ACTIVE_SIGNUP_VARIATION === 'short'
    capture('user signup office')
    const success = await dispatch(
      doOfficeOauth(
        V6_COMPANY_PAGE,
        {
          signup: true,
          ignore_existing: !!options.ignore_existing,
        },
        { rethrowErrorOnClosedPopup: true, disableRedirect: isShortSignup }
      )
    )
    if (success && isShortSignup) {
      await dispatch(doBootstrapOnboarding())
      dispatch(doFinishOnboarding())
    }
    return success
  }
}
